var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex justify-center items-center pointer"},[_c('input',{staticClass:"toggle hidden",attrs:{"type":"checkbox","id":_vm.id}}),_c('label',{staticClass:"switch",attrs:{"for":_vm.id}})])}
var staticRenderFns = []

export { render, staticRenderFns }